module.exports = __webpack_public_path__ + "img/t3.89e4a178.png";